import { TColors } from '@cian/ui-kit-design-tokens/colors';

import { EColor } from '../../repositories/dailyrent/entities/photo_label/PhotoLabel';

export const getTextColor = (labelColor: EColor): TColors => {
  switch (labelColor) {
    case EColor.GreenForCheckedOwner:
    case EColor.GreenForOwner:
    case EColor.Green:
    case EColor.GreenForSuperHost:
    case EColor.GreenForSuperAgent:
      return 'accent-positive-primary';
    default:
      return 'text-primary-default';
  }
};

export const getBackgroundColor = (labelColor: EColor): TColors => {
  switch (labelColor) {
    case EColor.GreenForCheckedOwner:
    case EColor.GreenForOwner:
    case EColor.Green:
    case EColor.GreenForSuperHost:
    case EColor.GreenForSuperAgent:
      return 'accent-positive-secondary';
    default:
      return 'accent-ghost-secondary';
  }
};
